export default __webpack_public_path__ + "static/image13-49bd28eef5d709b98df0a7993db8179a.jpg";